import React from 'react';
import { APIDetailsHeader } from "../common/ApiDetailsTabHeader";
import {
    SimpleTable,
    SimpleTableBody,
    SimpleTableContainer,
    SimpleTableHead,
    SimpleTableHeader,
    SimpleTableRow,
    SimpleTableData,
    SimpleTableWrapper,
    IconOpenInNew,
} from 'cdk-radial';
import "./ApiDetails.css";
import styled from 'styled-components';

const rowColors = {
    gray: '#f5f5f5',
    white: '#ffffff'
};

const StickySimpleTable = styled(SimpleTable)`
  position: relative;
  overflow: auto;
`;

const StickySimpleTableHeader = styled(SimpleTableHeader)`
  position: sticky;
  top: 0;
`;

const StickySimpleTableContainer = styled(SimpleTableContainer)`
  max-height: 60vh;
  overflow: auto;
`;

const StyledTableRow = styled(SimpleTableRow)`
  border-bottom: 1px solid #e0e0e0;
  height: 48px;
  background-color: ${props => props.bgColor || rowColors.white};
  &:hover {
    background-color: ${props => props.bgColor || rowColors.white} !important;
  }
`;

const StyledTableData = styled(SimpleTableData)`
  background-color: ${props => props.bgColor || rowColors.white};
`;

const DocLink = ({ text, url }) => {
    return (
        <a
            target="_blank"
            href={url}
            rel="noopener noreferrer"
            className="api-dir-pkg_bundle-doc-link-container"
        >
            <span className="api-dir-pkg_bundle-doc-link">{text}</span>
            <IconOpenInNew className="api-dir-pkg_bundle-doc-link-icon" />
        </a>
    );
};

const BundleDocumentation = ({
    bundleApis: data = [],
    auth,
}) => {
    let tableData = [];
    if (Array.isArray(data)) {
        tableData = data.flatMap((api, index) => {
            const docs = api?.externalDocs || [];
            const docsArray = Array.isArray(docs) ? docs : [];

            return docsArray.map((doc, docIndex) => ({
                apiId: api?.id,
                apiName: api?.name ? api?.name : "N/A",
                docName: doc?.name || "N/A",
                docUrl: doc?.url || doc?.urlLink,
                allDetails: api,
                rowSpan: docsArray.length,
                apiIndex: index + 1,
                isFirstOfGroup: docIndex === 0
            }));
        });
    }

    return (
      <div>
        <APIDetailsHeader title="Documentation" />
        <>
          {auth.isAuthenticated ? (
            <>
              <div className="api-dir-pkg_bundle-doc-table-heading">
                Included APIs ({data.length})
              </div>
              <SimpleTableWrapper
                data-testid="bundle-doc-table-wrapper"
                id="bundle-doc-table-wrapper"
                className="api-dir-pkg_bundle-doc-table-wrapper"
              >
                <StickySimpleTableContainer>
                  <StickySimpleTable
                    aria-label="API Documentation Table"
                    data-testid="bundle-api-docs-table"
                  >
                    <SimpleTableHead>
                      <SimpleTableRow>
                        <StickySimpleTableHeader
                          colSpan="1"
                          width="40%"
                          data-testid="bundle-doc-header-col-name"
                          className="api-dir-pkg_bundle-doc-table-header"
                        >
                          Name
                        </StickySimpleTableHeader>
                        <StickySimpleTableHeader
                          textAlign="left"
                          className="api-dir-pkg_bundle-doc-table-header"
                          colSpan="1"
                          data-testid="bundle-doc-header-col-document"
                        >
                          Document
                        </StickySimpleTableHeader>
                      </SimpleTableRow>
                    </SimpleTableHead>
                    <SimpleTableBody>
                      {tableData.map((row, index) => {
                        const isEvenStripe = row.apiIndex % 2 === 0;
                        const rowBgColor = isEvenStripe
                          ? rowColors.gray
                          : rowColors.white;
                        return (
                          <StyledTableRow
                            key={`${row.apiId}-${row.docName}-${index}`}
                            data-testid={`bundle-doc-row-${index}`}
                            bgColor={rowBgColor}
                          >
                            {row.isFirstOfGroup && (
                              <StyledTableData
                                textAlign="left"
                                rowSpan={row.rowSpan}
                                bgColor={rowBgColor}
                              >
                                {row.apiName}
                              </StyledTableData>
                            )}
                            <StyledTableData
                              textAlign="left"
                              bgColor={rowBgColor}
                            >
                              <DocLink text={row.docName} url={row.docUrl} />
                            </StyledTableData>
                          </StyledTableRow>
                        );
                      })}
                    </SimpleTableBody>
                  </StickySimpleTable>
                </StickySimpleTableContainer>
              </SimpleTableWrapper>
            </>
          ) : (
            <div>
              <div className="api-dir-pkg_no-documentation-text">
                <a
                  className="api-dir-pkg_cursor-pointer"
                  onClick={() => {
                    auth.login();
                  }}
                >
                  Sign in
                </a>{" "}
                to view bundle API documentation.
              </div>
            </div>
          )}
        </>
      </div>
    );
};

export default BundleDocumentation;
